module.exports = __webpack_public_path__ + "assets/fs-yiwancheng.d11509a5.svg";